export default "__VITE_ASSET__pixO9muO__"